import uuid from 'react-uuid'
const uid = () => uuid()

export default uid
